import { Grid } from '@mui/material';

import { TextField, Select } from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';

import { LimitTimePeriod } from '../types';

const day = [
  { label: 'Daily', value: LimitTimePeriod.Day },
  { label: 'Weekly', value: LimitTimePeriod.Week },
  { label: 'Monthly', value: LimitTimePeriod.Month },
  { label: 'Total', value: LimitTimePeriod.Total },
];

interface LimitFormContentProps {
  name: string;
  limitLabel?: string;
}

export const LimitFormContent = ({ name, limitLabel }: LimitFormContentProps) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={3}>
        <TextField
          name={`${name}.limit`}
          label={limitLabel || 'Times'}
          fieldProps={{
            parse: parseNumber,
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <Select
          name={`${name}.timePeriod`}
          label='Frequency'
          data={day}
          formControlProps={{ size: 'medium', margin: 'none' }}
        />
      </Grid>
    </Grid>
  );
};
